import { useMutation } from '@apollo/client'
import { setAllRequests } from '_reducers/puzzleRequests'
import { useAppDispatch } from '_store'
import { AuthContext } from 'AuthContext'
import { EledoFormGenerator, EledoPageHeader, EledoPendingContent } from 'components/library'
import { AuthenticateDataData, AuthenticateVars, AuthUserCreate, GET_AUTHENTICATE } from 'graphql/AuthQueries'
import React, { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import classnames from "classnames";
import styles from 'components/library/EledoPageHeader.module.scss';
import { FormProvider, useForm } from 'react-hook-form'
import ReactTooltip from 'react-tooltip'
import { PlatformContext } from 'PlatformContext'
import { CreateAccountFormModel } from 'model/login'
import { Tracker, TrackerUser } from 'Tracker'


type LocationState = {
  userId: string
  type: string
  provider: string
  payload: string
  rememberMe: boolean
  email: string
  from: {
    pathname: string
    search: string
  }
}

type CreateAccountFormData = {
  signupTerms: boolean
  signupNewsletter: boolean
}

const EledoCreateAccount = () => {
  const auth = useContext(AuthContext);
  const platform = useContext(PlatformContext);
  const navigate = useNavigate()
  const state = useLocation().state as LocationState; //console.log("CreateAccount state", state)
  const [rememberMe, setRememberMe] = useState(state.rememberMe)

  const formHandler = useForm<CreateAccountFormData>({mode: "onChange"});
  const { formState: {isValid, isSubmitted} } = formHandler;

  const onSubmitHandler = (data: CreateAccountFormData) => {

    if(isValid) {
          platform.authService.provideAuthUserCreate()
            .then(provided => {

              const create: AuthUserCreate = {
                locale: provided?.locale,
                timezone: provided?.timezone,
                language: provided?.language,
                countryCode: provided?.countryCode,

                source: process.env.REACT_APP_PLATFORM,
                signupTerms: data.signupTerms,
                signupNewsletter: data.signupNewsletter
              }
              
              const authenticate: AuthenticateVars = {
                userId: state.userId,
                type: state.type,
                payload: state.payload,
                create
              }
              
              doAuth({ variables: authenticate });
            })
        }
  }

  const dispatch = useAppDispatch();
  const [doAuth, { loading, error }] = useMutation<AuthenticateDataData, AuthenticateVars>(GET_AUTHENTICATE, {
    onCompleted(data, clientOptions) {
      if(data){
        
        // console.log(data)
        
        if(data){
          const authVars = clientOptions?.variables as AuthenticateVars

          const trackerUser: TrackerUser = {
            id: data.authenticate.user?.id || null,
            level: data.authenticate.level
          }

          Tracker.event("action.register.account", trackerUser, null)
          
          auth.login(data.authenticate, authVars.type);
          
          if(data.authenticate.requests){
            dispatch(setAllRequests(data.authenticate.requests));
          }
// console.log(state.from)
          if(data.authenticate.user !== null){
            if(state?.from?.pathname){
              navigate(state.from.pathname + state.from.search);
            }else{
              navigate("/templates/mine");
            }
          }
        }
      }
    },
    onError(error){
    }
  });

  return (
    <div>
      <EledoPageHeader/>

      <div className={classnames(styles.EledoLogin, "container")} data-testid="EledoLogin">
        <div className="section section-small">
          <div className="hero-paragraph text-center">
            <h1>Create Account</h1>
          </div>
              <div className="col-50 center">
                
                { error === undefined &&
                  <FormProvider {...formHandler}>
                    <form onSubmit={formHandler.handleSubmit(onSubmitHandler)}>
                      <div style={{width: "330px"}} className="center">
                        <EledoFormGenerator formModel={CreateAccountFormModel}
                                            editedDataObject={{}}/>

                        {error !== undefined && <span className="center text-center" style={{display: "block"}}>
                          <small className="error-message" style={{float: "initial"}}>{error}</small>
                        </span>}

                        <div className="hero-paragraph text-center">
                          <span data-tip={isSubmitted || isValid || loading ? "" : "Please check required fields"}
                                data-for={isSubmitted || isValid || loading ? "" : 'login-button-tooltip'}>
                            <button className={"button"} type="submit"
                                  {...(isValid ? {} : {"aria-disabled": "true"})}>
                              <EledoPendingContent state={loading}
                                                  content="Create Account"
                                                  pendingContent="Working..."/>
                            </button>
                          <ReactTooltip
                            id="login-button-tooltip"
                            place="right"
                            type="warning"
                            effect="float"
                            multiline={true}
                          />
                          </span>
                        </div>


                        
                      </div>
                    </form>
                  </FormProvider>
                }

                {error !== undefined && 
                  <div style={{width: "330px"}} className="center text-center">
                    <p>Failed: {error.message}</p>
                    <button className={"button"} type="submit" onClick={() => navigate('/login/start')}>
                      Start Over
                    </button>
                  </div>}

                {/* <input type="checkbox" checked={rememberMe} onClick={() => {setRememberMe(!rememberMe)}}></input> */}


              </div>
        </div>
      </div>
    </div>
  )
}

export default EledoCreateAccount